import React from 'react'
import PropTypes from 'prop-types'

import ValidatedInput from '../ValidatedInput'
import { emailValidator } from '../../../helpers/validationRules'
import {
  NoMarkErrorComponent,
  SuccessComponent
} from '../DefaultTooltipComponents'

const ValidatedEmailInput = React.forwardRef(
  ({ message, successIcon, errorIcon, ...restProps }, ref) => {
    const rules = message
      ? [
          {
            match: emailValidator,
            successMessage: message,
            errorMessage: message
          }
        ]
      : []
    return (
      <ValidatedInput
        ErrorComponent={NoMarkErrorComponent}
        SuccessComponent={SuccessComponent({ successIcon, errorIcon })}
        rules={rules}
        ref={ref}
        {...restProps}
      />
    )
  }
)

ValidatedEmailInput.propTypes = {
  message: PropTypes.string
}

ValidatedEmailInput.defaultProps = {
  message: ''
}

export default ValidatedEmailInput
